import { render, staticRenderFns } from "./AnnouncementManagement.vue?vue&type=template&id=30f0a964&scoped=true&"
import script from "./AnnouncementManagement.vue?vue&type=script&lang=js&"
export * from "./AnnouncementManagement.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementManagement.vue?vue&type=style&index=0&id=30f0a964&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f0a964",
  null
  
)

export default component.exports